export default "__VITE_ASSET__DP4u053___"